import React from 'react';
import {
    Button
} from 'react-bootstrap';
import Swal from 'sweetalert2';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Axios from 'axios';
import Configs from '../../../Configs';
import Parse from '../../../Parse';

class MoreConfigurationsButton extends React.PureComponent {

    state = {
        openPopup: false,
        loading: false,
        params: {},
        isEmpty: false
    };

    componentDidMount() {
       this.getControllerStatus()
    }

    getControllerStatus = () => {
        const object = this.props.object;
        this.setState({
            loading: true
        })
        if(object == undefined) {
            this.setState({
                isEmpty: true
            })
            return;
        }
        if(object.relation_owner == undefined || object.relation_owner._value == undefined) {
            this.setState({
                isEmpty: true
            })
            return;
        }
        const ownerId = object.relation_owner._value ? object.relation_owner._value : "";
        const controller = object.controller;
        Axios.post(`${Configs.serverUrl}/api/member/${ownerId}/controller/${controller}/status`).then(res => {
            const data = res.data;
            this.setState({
                loading: false,
                isEmpty: false,
                params: {
                    ...data
                }
            })
        }).catch(res => {
            this.setState({
                loading: false,
                isEmpty: true
            })
        })
    }

    updateServerConfig = () => {
        const params = {...this.state.params};
        this.setState({
            loading: true
        })
        Parse.Cloud.run("updateServerConfig", {
            ...params
        })
        .then((res) => {
            this.setState({
                loading: false
            }, () => {
                Swal.fire(`Update information Successful`);
                this.props.history.push(`/object/${this.props.classes}`);
            })
        })
        .catch((err) => {
            this.setState({
                loading: false
            })
            Swal.fire(`Error when Update information`);
        })
    }

    closePopupHandler = () => {
        this.setState({
            openPopup: false,
        })
    }

    openPopupHandler = () => {
        this.setState({
            openPopup: true,
        })
    }

    inputChangeHandler = (val, key, value) => {
        const params = {...this.state.params};
        this.setState({
            params: {
                ...params,
                [key]: {
                    ...params[key],
                    [value]: val
                }
            }
        })
    }

    render () {
        const params = {...this.state.params};
        return (
            <React.Fragment>
                <Button variant="success pull-right" onClick={() => this.openPopupHandler()}>
                    <i className="fa fa-cog"></i>
                    <span className="hidden-xs hidden-sm">&nbsp;Server Config</span>
                </Button>
                {
                    this.state.openPopup ? (
                        <div className="MoreButtonPopup">
                            <div className="popup_image_bover">
                            </div>
                            <div className="popup_image form-popup">
                                <div className="form-container">
                                    <div className="popup_header">
                                        <h3 className="pull-left">Configurations</h3>
                                    </div>
                                    <div className="popup_body">
                                        {
                                            this.state.loading ? (
                                                <Spinner></Spinner>
                                            ) : (
                                                <div className="col-md-12 col-xs-12 col-lg-12">
                                                    <div className={`form-group ${ params.GPayRestaurant !== undefined && params.GPayRestaurant.id !== undefined && !params.GPayRestaurant.id ? `has-error` : ""}`}>
                                                        <label>GPayRestaurant -> api_url</label>
                                                        <input type="text" className="form-control" value={params.GPayRestaurant !== undefined && params.GPayRestaurant.api_url !== undefined && params.GPayRestaurant.api_url ? params.GPayRestaurant.api_url : ""} onChange={(e) => {
                                                            this.inputChangeHandler(e.target.value, "GPayRestaurant", "api_url");
                                                        }} disabled={params.GPayRestaurant !== undefined && params.GPayRestaurant.id !== undefined && !params.GPayRestaurant.id} />
                                                        {
                                                            params.GPayRestaurant !== undefined && params.GPayRestaurant.id !== undefined && !params.GPayRestaurant.id ? (
                                                                <span className="help-block">{`No record Gpay Restaurant`}</span>
                                                            ) : null
                                                        }
                                                    </div>
                                                    <div className={`form-group ${ params.GrabFoodRestaurant !== undefined && params.GrabFoodRestaurant.id !== undefined && !params.GrabFoodRestaurant.id ? `has-error` : ""}`}>
                                                        <label>GrabFood Restaurant -> orderUrl</label>
                                                        <input type="text" className="form-control" value={params.GrabFoodRestaurant !== undefined && params.GrabFoodRestaurant.orderUrl !== undefined && params.GrabFoodRestaurant.orderUrl ? params.GrabFoodRestaurant.orderUrl : ""} onChange={(e) => {
                                                            this.inputChangeHandler(e.target.value, "GrabFoodRestaurant", "orderUrl");
                                                        }} disabled={params.GrabFoodRestaurant !== undefined && params.GrabFoodRestaurant.id !== undefined && !params.GrabFoodRestaurant.id} />
                                                        {
                                                            params.GrabFoodRestaurant !== undefined && params.GrabFoodRestaurant.id !== undefined && !params.GrabFoodRestaurant.id ? (
                                                                <span className="help-block">{`No record GrabFood Restaurant`}</span>
                                                            ) : null
                                                        }
                                                    </div>
                                                    <div className={`form-group ${ params.menu !== undefined && params.menu.id !== undefined && !params.menu.id ? `has-error` : ""}`}>
                                                        <label>menu -> serverUrl</label>
                                                        <input type="text" className="form-control" value={params.menu !== undefined && params.menu.serverUrl !== undefined && params.menu.serverUrl ? params.menu.serverUrl : ""} onChange={(e) => {
                                                            this.inputChangeHandler(e.target.value, "menu", "serverUrl");
                                                        }} disabled={params.menu !== undefined && params.menu.id !== undefined && !params.menu.id} />
                                                        {
                                                            params.menu !== undefined && params.menu.id !== undefined && !params.menu.id ? (
                                                                <span className="help-block">{`No record Menu`}</span>
                                                            ) : null
                                                        }
                                                    </div>
                                                    <div className={`form-group ${ params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id ? `has-error` : ""}`}>
                                                        <label>userPlanDevice -> option1 -> plan_server_url</label>
                                                        <input type="text" className="form-control" value={params.userPlanDevice !== undefined && params.userPlanDevice.plan_server_url !== undefined && params.userPlanDevice.plan_server_url ? params.userPlanDevice.plan_server_url : ""} onChange={(e) => {
                                                            this.inputChangeHandler(e.target.value, "userPlanDevice", "plan_server_url");
                                                        }} disabled={params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id} />
                                                        {
                                                            params.userPlanDevice !== undefined && params.userPlanDevice.id !== undefined && !params.userPlanDevice.id ? (
                                                                <span className="help-block">{`No record User Plan Device`}</span>
                                                            ) : null
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="popup_footer">
                                        <div className="row">
                                            <div className="col-xs-4 col-md-4 col-lg-4 buttonFooter">
                                                <button className="btn btn-primary btn-block" onClick={this.updateServerConfig}>Save</button>
                                            </div>
                                            <div className="col-xs-4 col-md-4 col-lg-4 buttonFooter">
                                                <button className="btn btn-default btn-block" onClick={this.getControllerStatus}>Refresh</button>
                                            </div>
                                            <div className="col-xs-4 col-md-4 col-lg-4 buttonFooter">
                                                <button className="btn btn-default btn-block" onClick={this.closePopupHandler}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null
                }
            </React.Fragment>
        )
    }
}

export default MoreConfigurationsButton;